'use client';

import { useShortlist } from '@/lib/getters/useShortlist';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import EventCard from '../EntryCards/EventCard';
import SkeletonCards from '../SkeletonCards';
import Grid from '../ui/Grid';
import Txt from '../ui/Txt';

const Shortlist = () => {
  const searchParams = useSearchParams();
  const t = useTranslations('common');

  const idParam = searchParams.get('id');

  const ids = idParam ? idParam.split(',') : [];

  const { data, loading, error } = useShortlist({ id: ids, conceal: false });

  let inner: React.ReactNode | null = null;

  if (error) inner = null;

  if (loading)
    inner = (
      <SkeletonCards
        amount={3}
        md={6}
        lg={4}
        SkeletonItems={{
          items: [
            { variant: 'rounded', height: 200 },
            { variant: 'rounded', height: 30, width: '90%' },
            { variant: 'rounded', height: 15, width: '50%' },
          ],
        }}
      />
    );

  if (data.length > 0)
    inner = (
      <Grid>
        {data?.map((event, index) => {
          return (
            event && (
              <Grid.Col key={index} md={6} lg={4}>
                <EventCard data={event} />
              </Grid.Col>
            )
          );
        })}
      </Grid>
    );

  if (data.length === 0 && !loading) inner = <Txt>{t('noShortlistItems')}</Txt>;

  return inner;
};

export default Shortlist;
